/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createE } from '../../factoriesAny.js';
export var eDependencies = {
  BigNumberDependencies,
  createE
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesE.generated.js
// module id = null
// module chunks = 